import React, { useState } from "react";
import { useFormikContext } from "formik";
import {
  toggleAllGroupFeaturesForProduct,
  canTurnAllProductFeaturesOffCol
} from "utils/feature";
import classnames from "classnames";
import cloneDeep from "lodash/cloneDeep";
import HoverIconButton from "components/HoverIconButton";
import Analytics, {
  TOGGLE_ALL_GROUP_FEATURES_FOR_PRODUCT
} from "utils/analytics";

const ENTITLEMENTS = "entitlements";

const CellEntitlementHeader = ({
  tracking,
  featureGroup,
  product,
  features,
  tdWidth,
  productIndex,
  activeIndex,
  isLast
}) => {
  const {
    values,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormikContext();

  const [hoverCell, setHoverCell] = useState(false);
  const featuresInGroup = features.filter(
    (feature) => featureGroup.feature_uuids.indexOf(feature.uuid) > -1
  );
  const productId = product.id;
  const canToggleAllOff = canTurnAllProductFeaturesOffCol({
    features: featuresInGroup,
    productId,
    entitlements: values.entitlements
  });
  const isTouched = Boolean(touched[ENTITLEMENTS]);

  const toggleAllForProduct = () => {
    Analytics.track(TOGGLE_ALL_GROUP_FEATURES_FOR_PRODUCT, tracking);
    const updatedEntitlements = toggleAllGroupFeaturesForProduct({
      entitlements: cloneDeep(values.entitlements),
      features: featuresInGroup,
      productId,
      toggleAllOff: canToggleAllOff
    });

    setFieldValue(ENTITLEMENTS, updatedEntitlements);
    if (!isTouched) {
      setFieldTouched(ENTITLEMENTS, true);
    }
  };

  const containerProps = {
    className: classnames("tc bb hairline-1 relative dtc-ns", {
      "bg-white": !hoverCell,
      "bg-content--secondary": hoverCell,
      "br": isLast,
      "dn": activeIndex !== productIndex
    }),
    onMouseEnter: () => !hoverCell && setHoverCell(true),
    onMouseLeave: () => hoverCell && setHoverCell(false)
  };
  const toggleAllButton = (
    <HoverIconButton
      type="down"
      tooltip={`Toggle all ${canToggleAllOff ? "off" : "on"}`}
      size={20}
      onClick={toggleAllForProduct}
    />
  );

  return (
    <th {...containerProps} style={{ width: `${tdWidth}%` }}>
      <div
        className={classnames(
          "flex flex-row items-center w-100 h-100 justify-between"
        )}
      >
        {hoverCell && (
          <div className="dn flex-ns h-100 fw4 items-end justify-center absolute bottom-0 left-0 right-0">
            {toggleAllButton}
          </div>
        )}
        <div className="flex dn-ns h-100 fw4 items-end justify-center absolute bottom-0 left-0 right-0">
          {toggleAllButton}
        </div>
      </div>
    </th>
  );
};

export default CellEntitlementHeader;
